import type { Inquiry, CreateInquiryInput, UpdateInquiryInput } from '@peles/shared';
import { apiClient } from './client';
import axios from 'axios';

/**
 * Create a new inquiry (public, no auth required).
 * Uses raw axios instead of apiClient to avoid auth interceptor.
 */
export async function createInquiry(input: CreateInquiryInput): Promise<Inquiry> {
  const { data } = await axios.post<Inquiry>('/api/v1/inquiries', input);
  return data;
}

export async function getInquiries(filters?: { status?: string }): Promise<Inquiry[]> {
  const params: Record<string, string> = {};
  if (filters?.status) params.status = filters.status;
  const { data } = await apiClient.get<Inquiry[]>('/inquiries', { params });
  return data;
}

export async function updateInquiryStatus(id: string, input: UpdateInquiryInput): Promise<Inquiry> {
  const { data } = await apiClient.patch<Inquiry>(`/inquiries/${id}`, input);
  return data;
}

export interface ConvertInquiryResult {
  event: { id: string; name: string };
  user: { id: string; email: string; name: string };
  inquiry: { id: string; status: string };
}

export async function convertInquiryToEvent(id: string): Promise<ConvertInquiryResult> {
  const { data } = await apiClient.post<ConvertInquiryResult>(`/inquiries/${id}/convert`);
  return data;
}
